module.exports = __webpack_public_path__ + "img/valuationResultSpecialty.c6ed9873.png";